const signDocuments = {
  laboratory: {
    key: 'laboratory',
    label: 'laboratory',
    type: 'enum',
    enum: 'laboratories',
    sortable: false,
  },
  documentType: {
    key: 'documentType',
    label: 'documentType',
    type: 'enum',
    enum: 'documentType',
    sortable: false,
    minWidth: 80,
  },
  description: {
    key: 'description',
    label: 'description',
    type: 'text',
    sortable: false,
    minWidth: 160,
  },
  isSigned: {
    key: 'isSigned',
    label: 'isSigned',
    type: 'boolean',
    sortable: false,
    minWidth: 50,
  },
  signedAt: {
    key: 'signedAt',
    label: 'signedAt',
    type: 'date',
    sortable: false,
    minWidth: 80,
  },
  signedBy: {
    key: 'signedBy.username',
    label: 'signedBy',
    type: 'text',
    sortable: false,
    minWidth: 80,
  },
  actions: {
    key: 'actions',
    label: 'actions',
    type: 'actions',
    sortable: false,
    fixed: true,
    minWidth: 100,
    buttons: [
      {
        name: 'viewDocumentPdf',
        icon: 'fas fa-eye',
      },
      {
        name: 'signDocument',
        icon: 'fas fa-file-signature',
        showCondition: (row) => !row.isSigned,
      },
      {
        name: 'downloadSignedPdf',
        icon: 'fas fa-file-pdf',
        showCondition: (row) => row.isSigned,
      },
    ],
  },
};

export default signDocuments;
